/**
 * Superitalia – Starter Set: max. 1 per cart
 *
 * Drei Absicherungsebenen:
 *  1. CartQuantity.prototype.updateCart – direkt abgefangen vor jedem fetch
 *  2. Fetch-Interceptor /cart/add  – blockiert ATC wenn Bundle bereits im Cart
 *  3. Fetch-Interceptor /cart/change + /cart/update – Fallback für sonstige Wege
 */
(function () {
  'use strict';

  var BUNDLE_IDS = [
    15580905767243,
    15604156957003,
    15604157808971,
    15604155416907
  ];
  var MSG = 'Jedes Starter Set kann nur 1× pro Bestellung gekauft werden.';

  function isBundleProduct(productId) {
    return BUNDLE_IDS.indexOf(Number(productId)) !== -1;
  }

  function cartHasBundle(cart) {
    return cart.items.some(function (item) {
      return isBundleProduct(item.product_id);
    });
  }

  // ── Toast ──────────────────────────────────────────────────────────
  function showError() {
    var existing = document.getElementById('si-bundle-limit-toast');
    if (existing) { existing.remove(); }

    var style = document.createElement('style');
    style.textContent = '@keyframes si-toast-in{from{opacity:0;transform:translateX(-50%) translateY(8px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}';
    document.head.appendChild(style);

    var toast = document.createElement('div');
    toast.id = 'si-bundle-limit-toast';
    toast.textContent = MSG;
    toast.style.cssText = [
      'position:fixed', 'bottom:24px', 'left:50%', 'transform:translateX(-50%)',
      'background:#1a1a1a', 'color:#fff', 'font-family:Satoshi,sans-serif',
      'font-size:13px', 'font-weight:600', 'padding:12px 20px',
      'border-radius:4px', 'z-index:99999', 'max-width:90vw',
      'text-align:center', 'box-shadow:0 4px 16px rgba(0,0,0,.25)',
      'animation:si-toast-in .2s ease'
    ].join(';');

    document.body.appendChild(toast);
    setTimeout(function () { toast.remove(); }, 5000);
  }

  // ── 1. CartQuantity.prototype.updateCart patchen ──────────────────
  // Greift cart-weit (Cart-Page + Cart-Drawer), bevor der fetch passiert.
  function patchCartQuantity() {
    customElements.whenDefined('cart-quantity').then(function () {
      var CartQuantity = customElements.get('cart-quantity');
      if (!CartQuantity || CartQuantity.prototype.__siBundlePatched) return;
      CartQuantity.prototype.__siBundlePatched = true;

      var _origUpdateCart = CartQuantity.prototype.updateCart;

      CartQuantity.prototype.updateCart = function (line, quantity) {
        var self = this;

        // Quantity 0 = Remove → immer erlauben
        if (quantity <= 1) {
          return _origUpdateCart.call(self, line, quantity);
        }

        // Prüfen ob dieses Line-Item ein Bundle ist
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var item = cart.items[line - 1];
            if (item && isBundleProduct(item.product_id)) {
              // Input-Wert im UI sofort zurücksetzen
              if (self.input) { self.input.value = '1'; }
              showError();
              return; // kein updateCart
            }
            return _origUpdateCart.call(self, line, quantity);
          })
          .catch(function () {
            return _origUpdateCart.call(self, line, quantity);
          });
      };
    });
  }

  // ── 2. Fetch-Interceptor ───────────────────────────────────────────
  var _fetch = window.fetch;
  window.fetch = function () {
    var args = Array.prototype.slice.call(arguments);
    var url  = typeof args[0] === 'string' ? args[0] : ((args[0] && args[0].url) || '');
    var cfg  = args[1] || {};

    // /cart/add – blockieren wenn Bundle bereits im Cart
    if (url.indexOf('/cart/add') !== -1 && cfg.body) {
      try {
        var addBody = JSON.parse(cfg.body);
        var items = addBody.items || (addBody.id ? [addBody] : []);
        var addingBundle = items.some(function (item) {
          return isBundleProduct(item.id);
        });

        if (addingBundle) {
          return _fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              if (cartHasBundle(cart)) {
                showError();
                return new Response(
                  JSON.stringify({ description: MSG, status: 422 }),
                  { status: 422, headers: { 'Content-Type': 'application/json' } }
                );
              }
              return _fetch.apply(window, args);
            });
        }
      } catch (e) { /* ignore */ }
    }

    // /cart/change – Fallback (z.B. direkte API-Calls, andere Scripts)
    if (url.indexOf('/cart/change') !== -1 && cfg.body) {
      try {
        var changeBody = JSON.parse(cfg.body);
        var newQty = parseInt(changeBody.quantity, 10);

        if (newQty > 1) {
          return _fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var isBundleItem = false;

              if (changeBody.line) {
                var lineItem = cart.items[changeBody.line - 1];
                if (lineItem && isBundleProduct(lineItem.product_id)) isBundleItem = true;
              } else if (changeBody.id) {
                var found = cart.items.find(function (i) {
                  return String(i.variant_id) === String(changeBody.id) ||
                         String(i.key)        === String(changeBody.id);
                });
                if (found && isBundleProduct(found.product_id)) isBundleItem = true;
              }

              if (isBundleItem) {
                showError();
                // Mit qty=1 weiterleiten (Sections-Parameter beibehalten)
                var fixedBody = Object.assign({}, changeBody, { quantity: 1 });
                return _fetch(url, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify(fixedBody)
                });
              }

              return _fetch.apply(window, args);
            })
            .catch(function () { return _fetch.apply(window, args); });
        }
      } catch (e) { /* ignore */ }
    }

    // /cart/update – Batch-Updates
    if (url.indexOf('/cart/update') !== -1 && cfg.body) {
      try {
        var updateBody = JSON.parse(cfg.body);
        if (updateBody.updates) {
          return _fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var modified = false;
              var safeUpdates = Object.assign({}, updateBody.updates);

              Object.keys(safeUpdates).forEach(function (key) {
                if (parseInt(safeUpdates[key], 10) > 1) {
                  var item = cart.items.find(function (i) {
                    return String(i.variant_id) === String(key) ||
                           String(i.key)        === String(key);
                  });
                  if (item && isBundleProduct(item.product_id)) {
                    safeUpdates[key] = 1;
                    modified = true;
                  }
                }
              });

              if (modified) {
                showError();
                return _fetch(url, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(Object.assign({}, updateBody, { updates: safeUpdates }))
                });
              }

              return _fetch.apply(window, args);
            })
            .catch(function () { return _fetch.apply(window, args); });
        }
      } catch (e) { /* ignore */ }
    }

    return _fetch.apply(window, args);
  };

  // ── Init ───────────────────────────────────────────────────────────
  patchCartQuantity();

  // Nach Drawer-Update erneut patchen (Custom Elements können neu gemountet werden)
  if (window.eventBus) {
    window.eventBus.on('update:cart:drawer', function () {
      setTimeout(patchCartQuantity, 200);
    });
  }
})();
